// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"e282a6e8","215":"04825e22","260":"8e587014","453":"dcb2ad55","767":"e6c2b52d"}[chunkId] + ".chunk.js";
};